/**
 * 具有权限的按钮
 */
import React from 'react';
import {InputNumber} from 'antd';
import './index.scss'
import {WWMethods} from "@/tools";
export default class WWInputNumber extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount() {

    }
    render() {
        // 将此组件的参数过滤
        const {type, className,onChange, ...otherProps} = this.props;
        return (
            <InputNumber type={type} className={className}  onChange={(e)=>{
                onChange(e);
            }} {...otherProps}/>
        )
    }
}
